<template>
    <b-button
        @click="$emit('click', $event)"
        class="rkm-navbar-nav-icon"
        pill
        title="Notas de versão"
    >
        <rkm-icon icon="book-open" />

        <rkm-badge
            v-if="quantidadeNotasVersaoNovas > 0"
            class="ml-1"
            color="danger"
        >
            {{quantidadeNotasVersaoNovas}}
        </rkm-badge>
    </b-button>
</template>

<script>
// Components.
import {BButton} from 'bootstrap-vue'

export default {
    components: {BButton},
    props: {
        quantidadeNotasVersaoNovas: {type: [Number, String], required: true},
    },
}
</script>

<style lang="scss" scoped>
$primary: #007bff;
.rkm-navbar-nav-icon {
    background-color: darken($primary, 10%) !important;
    border: none;
}
.rkm-navbar-nav-icon:hover {
    background-color: darken($primary, 15%) !important;
}
.rkm-navbar-nav-icon:active {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
.rkm-navbar-nav-icon:focus {
    background-color: darken($primary, 15%) !important;
    box-shadow: none !important;
}
</style>